export const NAV_LINKS = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "skills", label: "Skills" },
    { id: "projects", label: "Projects" },
    { id: "experience", label: "Experience" },
    { id: "education", label: "Education" },
    { id: "certifications", label: "Certifications" },
    { id: "contact", label: "Contact" },
];

export const CONTACT = {
    phone: "+1 437-227-6209",
    phoneHref: "tel:+14372276209",
    email: "itsharshgill@gmail.com",
    emailHref: "mailto:itsharshgill@gmail.com",
    linkedin: "www.linkedin.com/in/itsharshgill",
    linkedinHref: "https://www.linkedin.com/in/itsharshgill",
    github: "github.com/itsharshgill",
    githubHref: "https://github.com/itsharshgill",
};

export const SKILL_GROUPS = [
    {
        icon: "ShieldCheck",
        title: "Cybersecurity",
        skills: [
            "Network Penetration Testing",
            "Vulnerability Assessment",
            "Web Security Testing",
            "Reconnaissance",
            "Enumeration",
            "Security Misconfigurations",
            "OWASP Top 10",
            "Network Fundamentals",
            "Virtual Lab Setup",
        ],
    },
    {
        icon: "Terminal",
        title: "Security Tools",
        skills: [
            "Nmap",
            "Metasploit",
            "Burp Suite",
            "Hydra",
            "Gobuster",
            "SQLmap",
            "Wireshark",
            "John the Ripper",
        ],
    },
    {
        icon: "Code2",
        title: "Programming",
        skills: ["Python", "Java", "HTML", "CSS"],
    },
    {
        icon: "Database",
        title: "Databases",
        skills: ["SQL", "MySQL", "Database Management"],
    },
    {
        icon: "Server",
        title: "Systems",
        skills: ["Linux Administration", "Windows Server Administration"],
    },
    {
        icon: "Network",
        title: "Networking",
        skills: ["Cisco Networking", "Network Fundamentals", "Data Cabling"],
    },
];

export const PROJECTS = [
    {
        id: "01",
        slug: "bank-management",
        title: "Bank Management System",
        type: "CLI / Console Application",
        tech: ["SQL", "Programming", "Database"],
        description:
            "Developed a command-line bank management system using an SQL database to store, retrieve, and manage customer account information.",
        concepts: [
            "SQL Database",
            "Account Data Retrieval",
            "Database Operations",
            "Application Logic",
            "Structured Data Management",
        ],
        overview:
            "Developed a command-line bank management system using an SQL database to store, retrieve, and manage customer account information.",
        features: [
            "SQL database",
            "Account data retrieval",
            "Database operations",
            "Application logic",
            "Structured data management",
        ],
        learned: "Details to be added.",
        security: "Details to be added.",
        github: "https://github.com/itsharshgill/Python-MySQL-Bank-Management-System",
    },
    {
        id: "02",
        slug: "login-authentication",
        title: "Login & Authentication System",
        type: "CLI / Console Application",
        tech: ["Programming", "SQL", "Database"],
        description:
            "Developed a console-based login system integrated with a database to handle user authentication and account validation.",
        concepts: [
            "Authentication Logic",
            "Database Integration",
            "User Validation",
            "Access Control Concepts",
        ],
        overview:
            "Developed a console-based login system integrated with a database to handle user authentication and account validation.",
        features: [
            "Authentication logic",
            "Database integration",
            "User validation",
            "Access control concepts",
        ],
        learned: "Details to be added.",
        security: "Details to be added.",
        github: "https://github.com/itsharshgill/Python-Login-Authentication-System",
    },
    {
        id: "03",
        slug: "password-generator",
        title: "Password Generator",
        type: "CLI / Console Application",
        tech: ["Python"],
        description:
            "Developed a command-line password generation tool capable of creating randomized passwords based on configurable character combinations.",
        concepts: [
            "Password Generation",
            "Randomization",
            "Security Fundamentals",
            "Python Programming",
        ],
        overview:
            "Developed a command-line password generation tool capable of creating randomized passwords based on configurable character combinations.",
        features: [
            "Password generation",
            "Randomization",
            "Security fundamentals",
            "Python programming",
        ],
        learned: "Details to be added.",
        security: "Details to be added.",
        github: "https://github.com/itsharshgill/Python-Password-Generator",
    },
    {
        id: "04",
        slug: "inventory-management",
        title: "Inventory Management System",
        type: "CLI / Console Application",
        tech: ["Programming", "SQL", "Database"],
        description:
            "Developed a console-based inventory management system for managing and retrieving inventory records through structured application logic.",
        concepts: [
            "Inventory Records",
            "Data Retrieval",
            "Database Operations",
            "Application Logic",
        ],
        overview:
            "Developed a console-based inventory management system for managing and retrieving inventory records through structured application logic.",
        features: [
            "Inventory records",
            "Data retrieval",
            "Database operations",
            "Structured application logic",
        ],
        learned: "Details to be added.",
        security: "Details to be added.",
        github: "https://github.com/itsharshgill/Python-Inventory-Management-System",
    },
    {
        id: "05",
        slug: "car-rental-management",
        title: "Car Rental Management System",
        type: "CLI / Console Application",
        tech: ["Programming", "Database"],
        description:
            "Developed a command-line car rental application for managing rental-related information and application workflows.",
        concepts: [
            "Rental Data Management",
            "Application Workflows",
            "Database Operations",
            "Console Interface",
        ],
        overview:
            "Developed a command-line car rental application for managing rental-related information and application workflows.",
        features: ["Details to be added."],
        learned: "Details to be added.",
        security: "Details to be added.",
        github: "https://github.com/itsharshgill/Python-Car-Rental-Application",
    },
];

export const LABS = [
    {
        icon: "FlaskConical",
        title: "TryHackMe",
        text: "Hands-on cybersecurity training and virtual labs covering networking, Linux, reconnaissance, enumeration, and penetration-testing concepts.",
    },
    {
        icon: "Crosshair",
        title: "Penetration Testing Labs",
        text: "Practical training involving reconnaissance, enumeration, vulnerability identification, and exploitation in controlled environments.",
    },
    {
        icon: "Globe",
        title: "Web Security Testing",
        text: "Hands-on practice exploring web application security concepts and common vulnerabilities using tools such as Burp Suite.",
    },
    {
        icon: "Radar",
        title: "Network Security",
        text: "Practical learning focused on network fundamentals, reconnaissance, enumeration, and security analysis.",
    },
];

export const CERTIFICATIONS = [
    {
        title: "Google Cybersecurity Professional Certificate V2",
        provider: "Google",
        icon: "BadgeCheck",
    },
    {
        title: "Ethical Hacking Training (v13)",
        provider: "Ethical Hacking Training",
        icon: "ShieldHalf",
    },
    {
        title: "Python Programming Certification",
        provider: "Python Programming",
        icon: "Code2",
    },
    {
        title: "Cybersecurity Training & Hands-on Labs",
        provider: "TryHackMe",
        icon: "FlaskConical",
    },
];

export const EXPERIENCE = {
    title: "Industrial Maintenance Technician (Millwright)",
    company: "Freshstone Brands Inc.",
    location: "Ontario, Canada",
    period: "2023 – Present",
    bullets: [
        "Installed, aligned, and maintained industrial machinery including conveyors, pumps, motors, gearboxes, mixers, and packaging equipment.",
        "Performed preventive and predictive maintenance, diagnosing mechanical, hydraulic, and pneumatic issues to minimize downtime.",
        "Conducted welding, fabrication, and repairs, interpreting blueprints and schematics for accurate installations and modifications.",
        "Assisted with equipment upgrades, line improvements, and installation of new machinery while monitoring performance and reporting recurring issues.",
    ],
};

export const TRANSFERABLE_SKILLS = [
    ["Troubleshooting", "Security Analysis"],
    ["Root-Cause Analysis", "Vulnerability Analysis"],
    ["System Diagnostics", "Incident Investigation"],
    ["Preventive Maintenance", "Security Hardening"],
    ["Technical Documentation", "Security Documentation"],
];

export const EDUCATION = {
    degree: "Computer Engineering Technician",
    school: "Northern College of Applied Arts and Technology — Pures Campus",
    period: "2021 – 2022",
    location: "Scarborough, Ontario",
    coursework: [
        "Java",
        "Python",
        "HTML",
        "CSS",
        "MySQL",
        "Database Management",
        "Networking",
        "Cisco",
        "Data Cabling",
        "Windows Server Administration",
        "Linux System Administration",
        "Systems Security",
    ],
};

export const TIMELINE = [
    {
        period: "2021 – 2022",
        title: "Computer Engineering Technician",
        text: "Built a technical foundation in programming, networking, databases, Linux, Windows Server, and systems security.",
        state: "past",
    },
    {
        period: "2023 – Present",
        title: "Industrial Maintenance Technician / Millwright",
        text: "Developed real-world troubleshooting, root-cause analysis, diagnostics, and technical problem solving in industrial environments.",
        state: "past",
    },
    {
        period: "Present",
        title: "Cybersecurity Development",
        text: "Penetration Testing • Network Security • Linux • Vulnerability Assessment",
        state: "active",
    },
    {
        period: "Next",
        title: "Career Goal",
        text: "Cybersecurity Professional / Penetration Tester",
        state: "goal",
    },
];

export const MARQUEE_ITEMS = [
    "Penetration Testing",
    "Vulnerability Assessment",
    "Network Security",
    "Linux",
    "Python",
    "SQL",
    "Reconnaissance",
    "Enumeration",
    "OWASP Top 10",
    "Security Hardening",
];

export const ABOUT_SUMMARY =
    "Motivated Cybersecurity Enthusiast with hands-on experience in vulnerability assessment, penetration testing labs, and network security analysis. Strong foundation in networking, Linux systems, and security tools including Nmap, Metasploit, and Burp Suite. Proven troubleshooting and analytical skills developed through industrial maintenance experience combined with IT and cybersecurity training. Passionate about identifying vulnerabilities and improving system security.";

export const JOURNEY_STAGES = [
    {
        number: "01",
        title: "Computer Engineering",
        intro: "Built a foundation in:",
        items: [
            "Programming",
            "Networking",
            "Databases",
            "Linux",
            "Windows Server",
            "Systems Security",
        ],
    },
    {
        number: "02",
        title: "Industrial Maintenance",
        intro: "Developed real-world:",
        items: [
            "Troubleshooting",
            "Root-Cause Analysis",
            "Diagnostics",
            "Technical Problem Solving",
            "Preventive Maintenance",
            "Blueprint / Schematic Interpretation",
        ],
    },
    {
        number: "03",
        title: "Cybersecurity",
        intro: "Currently developing practical skills in:",
        items: [
            "Penetration Testing",
            "Vulnerability Assessment",
            "Network Security",
            "Web Security",
            "Linux",
            "Security Tools",
        ],
    },
];
